import { SetStateAction } from 'react';
import { TooltipProps } from 'recharts';
import {
  NameType,
  Payload,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent';

interface StickyTooltipProps extends TooltipProps<ValueType, NameType> {
  hasClicked: boolean;
  stopChange: boolean;
  recordTooltip: JSX.Element | null;
  setRecordTooltip: React.Dispatch<SetStateAction<JSX.Element | null>>;
  setStopChange: React.Dispatch<SetStateAction<boolean>>;
  formatterFunctions: Array<(value: number) => number | string>;
}

export const StickyTooltip = ({
  active,
  payload,
  label,
  hasClicked,
  stopChange,
  setStopChange,
  recordTooltip,
  setRecordTooltip,
  formatterFunctions,
}: StickyTooltipProps): JSX.Element | null => {
  const currentJSX =
    payload && active && !!payload.length ? (
      <div className="custom-tooltip">
        <label className="label">
          <strong>{`${label}`}</strong>
        </label>
        <div className="custom-tooltip-scrool">
          {payload.map((el: Payload<ValueType, NameType>, index: number) => (
            <p style={{ color: el.color }} key={index}>
              {el.name}:
              <strong> {formatterFunctions[index](el.value as number)}</strong>
            </p>
          ))}
        </div>
      </div>
    ) : null;
  if (hasClicked && stopChange) {
    return recordTooltip;
  }
  if (hasClicked && !stopChange) {
    setRecordTooltip(currentJSX);
    setStopChange(true);
    return currentJSX;
  }
  setStopChange(false);
  return currentJSX;
};
